export const MODAL_TEST_IDS = {
  wrapper: 'modal.view.wrapper',
} as const;

export const PROFILE_TEST_IDS = {
  header: {
    jobTitle: 'profile.header.text.jobTitle',
    username: 'profile.header.text.username',
  },
  panel: {
    title: 'profile.panel.text.title',
  },
} as const;

export const INPUT_TEST_IDS = {
  clear: 'input.icon.clear',
  select: {
    chevronDown: 'input.select.icon.chevronDown',
    chevronUp: 'input.select.icon.chevronUp',
  },
  timePicker: {
    clock: 'input.timePicker.icon.clock',
  },
} as const;
